import React from 'react';

const HourCategoryProgress = ({ categories }) => {
    if (!categories || categories.length === 0) {
        return (
            <div className="text-center py-4 text-gray-500">
                No hour categories available
            </div>
        );
    }

    return (
        <div className="space-y-4">
            {categories.map((category) => {
                const total = Number(category.required_hours || 0);
                const completed = Number(category.completed_hours || 0);
                const progress = total > 0 ? Math.min(100, (completed / total) * 100) : 0;

                return (
                    <div key={category.id} className="bg-white border border-gray-200 rounded-lg p-4">
                        <div className="flex items-center justify-between mb-2">
                            <div className="flex items-center space-x-2">
                                <div
                                    className="w-3 h-3 rounded-full"
                                    style={{ backgroundColor: category.color || '#6B7280' }}
                                />
                                <span className="font-medium text-gray-900">
                                    {category.display_name}
                                </span>
                            </div>
                            <span className="text-sm text-gray-600">
                                {completed} / {total} hrs
                            </span>
                        </div>

                        <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                            <div
                                className="h-full transition-all duration-500 rounded-full"
                                style={{
                                    width: `${progress}%`,
                                    backgroundColor: category.color || '#111111'
                                }}
                            />
                        </div>

                        <div className="flex justify-between text-xs text-gray-500 mt-1">
                            <span>{Math.round(progress)}% complete</span>
                            <span>
                                {category.pending_hours > 0 && `${category.pending_hours} hrs pending`}
                                {category.draft_hours > 0 && ` • ${category.draft_hours} hrs draft`}
                            </span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default HourCategoryProgress;
